import { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import invertersActions from '@state/inverters/actions';
import useVariables from '@common/hooks/useVariables';

import alarmsFieldsInfo from '@utils/dictionaries/alarmsFieldsInfo';

function useSimpleCondition({ groupIndex, index }) {

  const dataType = [
    { name: 'System Work Mode', edge_name: 'SysM' },
    { name: 'Priority', edge_name: 'Pri' },
    { name: 'Battery type', edge_name: 'BtTy' },
    { name: 'Fault Battery', edge_name: 'Even' },
    { name: 'Fault Grid', edge_name: 'EGrid' },
    // { name: 'Inverter run state', edge_name: 'SPHS' },
    // { name: 'Derating Mode', edge_name: 'DerM' },
  ];
  const sysm = [
    { edge_name: 0, name: 'Waiting module' },
    { edge_name: 1, name: 'Self-test mode' },
    { edge_name: 2, name: 'Reserved' },
    { edge_name: 3, name: 'SysFault module' },
    { edge_name: 4, name: 'Flash module' },
    { edge_name: 5, name: 'Grid and PV online' },
    { edge_name: 6, name: 'Grid online and PV offline' },
    { edge_name: 7, name: 'Grid offline and PV online' },
    // { edge_name: 8, name: 'Bat Offline mode Module' },
  ];
  const pri = [
    { edge_name: 0, name: 'Load first' },
    { edge_name: 1, name: 'Battery first' },
    { edge_name: 2, name: 'Grid first' },
  ];
  const btty = [
    { edge_name: 0, name: 'Lead - acid' },
    { edge_name: 1, name: 'Lithium battery' },
  ];
  const sphs = [
    { edge_name: 0, name: 'Waiting' },
    { edge_name: 1, name: 'Normal' },
    { edge_name: 3, name: 'Fault' },
  ];
  const derm = [
    { edge_name: 0, name: 'No derate' },
    { edge_name: 1, name: 'PV' },
    { edge_name: 2, name: '*' },
    { edge_name: 3, name: 'VAC' },
    { edge_name: 4, name: 'FAC' },
    { edge_name: 5, name: 'T Boost' },
    { edge_name: 6, name: 'Tinv' },
    { edge_name: 7, name: 'Contol' },
    { edge_name: 8, name: '*' },
    { edge_name: 9, name: 'Over Back by time' },
  ];
  const even = [
    { edge_name: 0, name: 'OK' },
    { edge_name: 1, name: 'FAIL' },
  ];
  const egrid = [
    { edge_name: 0, name: 'OK' },
    { edge_name: 1, name: 'FAIL' },
  ];
  const dispatch = useDispatch();
  const { alarmsFieldsLoading, alarmsFields } = useVariables();

  const isEditDefault = useSelector(({ inverters }) => inverters.isEditDefault);
  const orCondition = useSelector(
    ({ inverters: a }) => a.createEditValues.conditions[groupIndex][index],
  );

  const removeOrCondition = useCallback(() => {

    dispatch(invertersActions.removeOrCondition(groupIndex, index));
    // eslint-disable-next-line
  
  }, []);

  const onChangeOrCondition = useCallback(
    (name, value) => {

      if (name !== 'type' && name !== 'field') {

        const newParams = (function () {

          const params = { ...orCondition.values, [name]: value };
          const array = [value];
          if (name === 'params') {

            delete params.value;
            delete params.values;

          }
          return array;
          // return params;

        }());

        dispatch(
          invertersActions.changeOrCondition(groupIndex, index, {
            ...orCondition,
            params: { values: newParams },
          }),
        );
        return;

      }

      dispatch(
        invertersActions.changeOrCondition(groupIndex, index, {
          ...orCondition,
          [name]: value,
          // values: {},
        }),
      );

    },
    // eslint-disable-next-line
    [orCondition]
  );

  const mapAlarmsFields = useMemo(() => {

    const { results: fields } = alarmsFields;
    if (!fields) return null;

    const mapFields = fields.map((item) => ({
      ...item,
      inputNumberProps: alarmsFieldsInfo[item.edge_name] || null,
    }));

    return mapFields;

    // eslint-disable-next-line
  
  }, [alarmsFields]);

  const filterFields = useMemo(() => {

    if (!mapAlarmsFields) return [];

    const { field } = orCondition;
    const availablesFields = [];

    switch (field) {

      // case 'numeric_threshold':
      //   availablesFields =
      // ['pv1', 'pc1', 'pw1', 'pv2', 'pc2', 'pw2', 'pv3', 'pc3', 'pw3', 'pED', 'pET', 'pPT'];
      //   break;
      // case 'equality':
      //   availablesFields = ['dev', 'mod', 'lic', 'sta'];
      //   break;
      case 'SysM':
        return sysm;
      case 'Pri':
        return pri;
      case 'BtTy':
        return btty;
      case 'SPHS':
        return sphs;
      case 'DerM':
        return derm;
      case 'EGrid':
        return egrid;
      case 'Even':
        return even;
      default:
        break;

    }

    return mapAlarmsFields.filter(({ edge_name }) => availablesFields.includes(edge_name));

  }, [orCondition, mapAlarmsFields]);

  // const fieldSelected = useMemo(() => {

  //   const {
  //     values: field,
  //     // values: { field },
  //   } = orCondition || {};

  //   if (!field || !mapAlarmsFields) return null;
  //   return mapAlarmsFields.find(({ edge_name }) => edge_name === field);
  //   // eslint-disable-next-line

  // }, [orCondition.values ? orCondition.values.field : {}, mapAlarmsFields]);

  return {
    orCondition,
    removeOrCondition,
    onChangeOrCondition,
    alarmsFieldsLoading,
    filterFields,
    // fieldSelected,
    isEditDefault,
    dataType,
  };

}

export default useSimpleCondition;
